module.exports = __webpack_public_path__ + "img/logo-crew-united.07223e84.png";